import { NotificationType } from '../enums/notification-type.enum';

export interface NotificationToast {
    id: string;
    titleLocalizationKey: string;
    descriptionLocalizationKey: string;
    type: NotificationType;
    cssClassName: string;
    autoHideDelay: number;

    /**
     * REV-21374 — eine OPTIONALE Handlung im Toast, z. B. „Rueckgaengig".
     *
     * ⚠️ Rein additiv: ohne `actionLabelKey` sieht ein Toast aus wie bisher, und kein bestehender
     * Aufrufer muss etwas aendern. Die Handlung selbst reist NICHT als Funktion mit — ein Callback
     * in einer NgRx-Aktion waere nicht serialisierbar und wuerde die Zeitreise im DevTool brechen.
     * Stattdessen traegt der Toast eine `actionId`, und wer sie ausgelost hat, hoert auf
     * `getNotificationAction$()`.
     */
    actionLabelKey?: string;
    actionId?: string;

    /**
     * Zeigt einen ablaufenden Balken ueber `autoHideDelay` — die Frist, in der die Handlung
     * oben noch gilt.
     *
     * ⚠️ Nur sinnvoll ZUSAMMEN mit `actionLabelKey`. Ein Balken ohne Handlung zaehlt etwas
     * herunter, das der Leser nicht beeinflussen kann, und macht aus einer Meldung eine Drohung.
     *
     * ⚠️ Der Balken ist die ANZEIGE der Frist, nicht die Frist selbst: gemessen wird sie dort,
     * wo die Handlung passiert (der Host), damit beide dasselbe Ende haben. Ihn hier zu messen
     * hiesse, zwei Uhren zu haben, die auseinanderlaufen.
     */
    actionProgress?: boolean;
}
